class Accordion {
	constructor(domNode) {
		this.rootEl = domNode;
		this.buttonEl = this.rootEl.querySelector("button[aria-expanded]");

		const controlsId = this.buttonEl.getAttribute("aria-controls");
		this.contentEl = document.getElementById(controlsId);

		this.open = this.buttonEl.getAttribute("aria-expanded") === "true";

		this.transition = this.rootEl.dataset.transition ? this.rootEl.dataset.transition : "all 0.3s ease";
		this.rootEl.style.setProperty("--accordion-transition", this.transition);

		// add event listeners
		this.buttonEl.addEventListener("click", this.onButtonClick.bind(this));
	}

	onButtonClick() {
		this.toggle(!this.open);
	}

	toggle(open) {
		// don't do anything if the open state doesn't change
		if (open === this.open) {
			return;
		}

		// update the internal state
		this.open = open;

		// handle DOM updates
		this.buttonEl.setAttribute("aria-expanded", `${open}`);
		if (open) {
			this.rootEl.classList.add("active");

			// Handle button
			this.buttonEl.classList.add("active");

			// Handle content
			this.contentEl.removeAttribute("hidden");
			this.contentEl.style.transition = this.transition;
			this.contentEl.style.maxHeight = this.contentEl.scrollHeight + "px";
		} else {
			this.rootEl.classList.remove("active");

			// Handle button
			this.buttonEl.classList.remove("active");

			// Handle content
			this.contentEl.style.maxHeight = null;
			this.contentEl.addEventListener(
				"transitionend",
				() => {
					this.contentEl.setAttribute("hidden", "");
				},
				{ once: true }
			);
		}
	}

	// Add public open and close methods for convenience
	open() {
		this.toggle(true);
	}

	close() {
		this.toggle(false);
	}
}

// Init accordions
const accordions = document.querySelectorAll("[data-accordion]");
accordions.forEach((accordionEl) => {
	new Accordion(accordionEl);
});
